export default class DetalhesNotasFiscaisViewModel {
	constructor () {
		this.Id = undefined;
		this.RepresentanteId = undefined;
		this.NomeRepresentante = undefined;
		this.RazaoSocial = undefined;
		this.Cnpj = undefined;
		this.CodigoExterno = undefined;
		this.ClienteId = undefined;
		this.NotaFiscalId = undefined;
		this.FormaPagamentoId = undefined;
		this.SerieNotaFiscal = undefined;
		this.DataEmissaoFormatada = undefined;
		this.PercentualFrete = undefined;
		this.CodigoConsignatorio = undefined;
		this.ZonaFranca = undefined;
		this.CodigoFiscal = undefined;
		this.Origem = undefined;
		this.DescricaoDaNaturezaDaOperacap = undefined;
		this.CodigoDaNaturezaDaOperacao = undefined;
		this.PesoTotalBruto = undefined;
		this.PesoTotalLiquido = undefined;
		this.FormaDePagamento = undefined;
		this.PercentualDescontoIPI = undefined;
		this.ValorTotalIPI = undefined;
		this.PercentualICMS = undefined;
		this.ValorTotalICM = undefined;
		this.ValorDescontoMercadoria = undefined;
		this.ValorTotalBonificacao = undefined;
		this.ValorTotalMercadoria = undefined;
		this.ValorTotalNotaFiscalFatura = undefined;
		this.DadosAdicionalFiscal = undefined;
		this.DadosAdicionalLivre = undefined;
		this.SituacaoTexto = undefined;
		this.IndicadorFinalidadeTexto = undefined;
		this.IndicadorDeTipoFreteTexto = undefined;
		this.PesoTotalBrutoFormatado = undefined;
		this.PesoTotalLiquidoFormatado = undefined;
		this.ValorTotalIPIFormatado = undefined;
		this.ValorTotalICMFormatado = undefined;
		this.ValorTotalMercadoriaFormatado = undefined;
		this.ValorTotalNotaFiscalFaturaFormatado = undefined;
		this.NomeTransportadora = undefined;
	}
}